import {
  JOB_AD_FIELDS,
  JOB_AD_IMAGE_FIELDS,
} from "@/plugins/jobAdFields/jobAdFields";

export const JOB_ITEM_TEMPLATE_GRID_PROP = "item-template:grid";
export const JOB_ITEM_TEMPLATE_LIST_PROP = "item-template:list";

export const JOB_ITEM_VARIABLES = [
  ...JOB_AD_FIELDS,
  ...JOB_AD_IMAGE_FIELDS,
].map(({ field, label }) => ({
  key: field.toUpperCase(),
  label,
}));

export const DEFAULT_GRID_ITEM_TEMPLATE = `
        <div class="card h-100 job-item">
          <div class="card-body">
            <h4 class="caption h6 job-item-caption">{JOBITEM.LOCATION} | {JOBITEM.DEPARTMENT}</h4>
            <h3 class="card-title pb-3 border-bottom h5 job-item-heading">{JOBITEM.TITLE}</h3>
            <p class="card-text"><span class="pe-1">Application date:</span><span data-date="{JOBITEM.APPLICATION_DEADLINE}" class="job-item-application-date"></span></p>
            <p class="card-text text-truncate">{JOBITEM.CATEGORY}</p>
          </div>
          <div class="card-footer bg-transparent border-top-0">
            <div class="d-flex justify-content-end">
              <a href="{JOBITEM.JOB_URL}" class="btn btn-primary job-item-link">{JOBITEM.BUTTON_LABEL}<span class="fa fa-chevron-right fa-solid ps-2"></span></a>
            </div>
          </div>
        </div>
      `;

export const DEFAULT_LIST_ITEM_TEMPLATE = `<div class="row py-3 border-secondary-subtle border border-top-0 border-start-0 border-end-0 job-item">
      <div class="col col-12 col-lg-3 fw-bold py-2 job-item-heading">
        {JOBITEM.TITLE}
      </div>
      <div class="col col-12 col-lg-3 text-secondary py-2 job-item-caption">
        {JOBITEM.LOCATION} | {JOBITEM.DEPARTMENT}
      </div>
      <div class="col col-12 col-lg-3 text-secondary py-2">
        {JOBITEM.CATEGORY}
      </div>
      <div class="col col-12 col-lg-auto ms-auto align-items-center d-flex justify-content-lg-end justify-content-start fw-bold py-2">
        <a href="{JOBITEM.JOB_URL}" class="btn btn-primary job-item-link">{JOBITEM.BUTTON_LABEL}<span class="fa-chevron-right fa-solid ps-2"></span></a>
      </div>
    </div>  `;
